import { Link } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import { FounderStatement } from "@/components/FounderStatement";
import { Compass, DownloadSimple } from "@phosphor-icons/react";

export default function BigPicture() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#0D1B2A] vv-grain" data-testid="big-picture-page">
      <PublicHeader />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <img
          src="/big_picture.png"
          alt="Vintage Vantage — The Big Picture: one strategy, many paths, exponentially more outcomes"
          data-testid="big-picture-page-image"
          className="w-full h-auto max-w-6xl mx-auto rounded-lg border border-[#E5E0D6] shadow-2xl"
        />
        <div className="max-w-4xl mx-auto text-center mt-12 sm:mt-16">
          <Compass size={26} weight="fill" className="text-[#B47A3C] mx-auto mb-6 opacity-70" />
          <p className="font-serif-display text-2xl sm:text-3xl lg:text-[38px] leading-snug tracking-tight" data-testid="big-picture-page-quote">
            When seller knowledge becomes <span className="text-[#B47A3C]">portable</span>, valuable effort becomes a <span className="text-[#B47A3C]">force multiplier</span> of time, expertise, reach, and profitability.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 mt-10">
            <a
              href="/big_picture.png"
              download="vintage-vantage-the-big-picture.png"
              data-testid="big-picture-page-download"
              className="inline-flex items-center gap-2 text-sm font-semibold border border-[#0D1B2A] bg-[#0D1B2A] text-[#FDFBF7] px-5 py-2.5 rounded-md hover:bg-black transition-colors"
            >
              <DownloadSimple size={16} weight="bold" /> Download the graphic
            </a>
            <Link
              to="/"
              data-testid="big-picture-page-home"
              className="inline-flex items-center gap-2 text-sm font-semibold border border-[#D8D3C8] px-5 py-2.5 rounded-md hover:bg-[#F5F3ED] transition-colors"
            >
              Back to home
            </Link>
          </div>
        </div>
        <FounderStatement />
      </main>
    </div>
  );
}
